module.exports = __webpack_public_path__ + "home.560895ebc2c40253f0b7.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/images/backgrounds/home.jpg
// module id = ../../../../../src/assets/images/backgrounds/home.jpg
// module chunks = styles